/**
 * Gmail Email Templates by cloudHQ — reusable email templates inside Gmail
 *
 * Declares one web-accessible-resource entry (icons/*, stylesheets/*, wrapper.html, and a
 * javascripts/* glob that ships no files) whose matches list is scoped to the cloudhq.net
 * origins and mail.google.com — not every origin. So its resources are unreachable from an
 * arbitrary page; only those sites can detect it. We probe the cloudhq.net origin here.
 *
 * Manifest verified against version 1.0.3.11.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'llccdnmbipddnkhmldacpcjjcnljpoij';

export const cloudhqEmailTemplates: ExtensionDefinition = {
  id: ID,
  name: 'Gmail™ Email Templates by cloudHQ',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://www.cloudhq.net',
  notes:
    'WAR scoped to the cloudhq.net origins and mail.google.com, so only those sites can ' +
    'detect it. A negative result from any other origin proves nothing.',
  signals: [
    {
      id: 'war-wrapper-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch wrapper.html — the injected UI wrapper, exposed only to the scoped origins.',
      weight: 1,
      run: () => probeFetch(ID, 'wrapper.html'),
    },
    {
      id: 'war-gmail-templates-png',
      kind: 'web-accessible-resource',
      description:
        'Fetch icons/gmail_templates.png — a vendor-named icon, a second origin-scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'icons/gmail_templates.png'),
    },
    {
      id: 'war-main-gmail-templates-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch stylesheets/main_gmail_templates.css — the main stylesheet, a third ' +
        'origin-scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'stylesheets/main_gmail_templates.css'),
    },
  ],
};
